var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
var X = function X(props) {
  return React.createElement(
    Icon,
    _extends({ viewBox: '0 0 10 10' }, props),
    React.createElement(
      'g',
      null,
      React.createElement(
        'title',
        null,
        'x'
      ),
      React.createElement(
        'g',
        { fill: 'currentColor', fillRule: 'nonzero' },
        React.createElement('path', { d: 'M9.081.596L.596 9.081a.5.5 0 1 0 .707.708L9.79 1.303A.5.5 0 0 0 9.08.596z' }),
        React.createElement('path', { d: 'M9.789 9.081L1.303.596a.5.5 0 0 0-.707.707L9.081 9.79a.5.5 0 1 0 .708-.708z' })
      )
    )
  );
};
/*eslint-enable */

export default X;
//# sourceMappingURL=X.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/Icons/dist/components/X.js